<template>
    <a-card>
        <template slot="title">
            <span>运行报表</span>
        </template>
        <div>
            <a-row :gutter="16">
                <a-col :span="6">
                    <div class="statusBlock bg1">
                        <p class="statusTitle">任务数量</p>
                        <p class="statusValue">{{status.jobInfoCount}}</p>
                    </div>
                </a-col>
                <a-col :span="6">
                    <div class="statusBlock bg2">
                        <p class="statusTitle">调度次数</p>
                        <p class="statusValue">{{status.jobLogCount}}</p>
                    </div>
                </a-col>
                <a-col :span="6">
                    <div class="statusBlock bg3">
                        <p class="statusTitle">成功次数</p>
                        <p class="statusValue">{{status.jobLogSuccessCount}}</p>
                    </div>
                </a-col>
                <a-col :span="6">
                    <div class="statusBlock bg3">
                        <p class="statusTitle">执行器数量</p>
                        <p class="statusValue">{{status.executorCount}}</p>
                    </div>
                </a-col>
            </a-row>
        </div>
        <div>
            <a-row>
                <a-col :span="24">
                    <jobchart></jobchart>
                </a-col>
            </a-row>
        </div>
    </a-card>
</template>
<script>
import jobchart from './jobchart'
export default {
    components:{
        jobchart,
    },
    mounted(){
        this.getStatus()
    },
    data(){
        return {
            status:{
                executorCount: 0,
                jobInfoCount: 0,
                jobLogCount: 0,
                jobLogSuccessCount: 0,
            },
            
        }
    },
    methods:{
        getStatus(){
            let that = this;
            let params = {
            };
            that.$store.dispatch({
                type: "jobcenter/queryJobStatus",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    this.status = res.data.data
                }
            }).catch(() => {
            });
        }
    }
}
</script>
<style scoped>
    .statusBlock{
        width:100%;
    }

    .statusBlock p{
        color: white;
    }

    .statusTitle{
        font-size: 18px;
        padding: 20px 20px 0 20px;
        margin: 0;
    }

    .statusValue{
        font-size: 20px;
        padding: 16px 20px;
        font-weight: bold;
    }

    

    .bg1{
        background: #00c0ef;
    }

    .bg2{
        background: #f39c12;
    }

    .bg3{
        background: #00a65a;
    }
</style>